import { Flex, Card, CardHeader, CardBody, Image, Text, Box, Badge } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { IoChatbubble } from 'react-icons/io5';
import { BsBoxSeam } from 'react-icons/bs';
import emojiSoon from '../assets/images/emoji_soon.png';

const LinkButton = ({ icon: Icon, text, href, disabled }) => (
  <Box
    as={href && !disabled ? 'a' : 'div'}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    display="flex"
    alignItems="center"
    border="1px solid"
    borderColor="gray.200"
    borderRadius="lg"
    px={4}
    py={3}
    cursor={disabled ? 'default' : 'pointer'}
    _hover={!disabled && { bgColor: 'gray.50' }}
  >
    <Box mr={3} color={disabled ? 'gray.400' : 'gray.700'} display="flex" alignItems="center">
      <Icon size={18} />
    </Box>
    <Text flex="1" fontSize="sm" fontWeight="medium" color={disabled ? 'gray.400' : 'gray.800'}>
      {text}
    </Text>
    <ChevronRightIcon color="gray.400" />
  </Box>
);

function DodoDotStudio() {
  return (
    <Flex direction="column" alignItems="center" flex="1" py={4} px={4}>

      {/* 카카오톡 이모티콘 */}
      <Card maxW="sm" width="100%" overflow="hidden" padding={2} mb={4}>
        <Image src={emojiSoon} alt="카카오톡 이모티콘" borderRadius="md" />
        <CardHeader pb={2}>
          <Text fontSize="xl" fontWeight="bold">카카오톡 이모티콘</Text>
          <Text fontSize="sm" color="gray.500">커밍순</Text>
        </CardHeader>
        <CardBody pt={0}>
          <LinkButton icon={IoChatbubble} text="카카오톡 이모티콘 바로가기" disabled />
        </CardBody>
      </Card>

{/* 굿즈 */}
      <Card maxW="sm" width="100%" overflow="hidden" padding={2} mb={4}>
        <Box bg="gray.100" height="200px" borderRadius="md" />
        <CardHeader pb={2}>
          <Text fontSize="xl" fontWeight="bold">굿즈</Text>
          <Text fontSize="sm" color="gray.500">도도닷 캐릭터 굿즈</Text>
        </CardHeader>
        <CardBody pt={0}>
          <LinkButton icon={BsBoxSeam} text="굿즈 이미지 준비중" disabled />
        </CardBody>
      </Card>

    </Flex>
  );
}

export default DodoDotStudio;
